module.exports = __webpack_public_path__ + "static/img/cy33.c4af039d.png";